export enum Charts
{
	None = 0,
	RequestFulfillment = 1,
	ResourceCapacity = 2
}